module.exports = __webpack_public_path__ + "static/media/cv.5a60cadc.svg";